import React__default, { useRef, useCallback, useMemo } from 'react';
import { a as useForm, F as FormProvider } from '../../3rdPartyModules/react-hook-form/dist/index.esm-CTOtYSSt.js';
import { useUID, UIDPrefix } from '@amzn/storm-ui';
import { F as FormElementContext } from './contexts/FormElementContext-pUV2tgYQ.js';
import { F as FormIdProvider } from './contexts/FormId/FormIdProvider-B_7kO2ZK.js';
import { S as SubmitErrorMessageProvider } from './contexts/SubmitErrorMessage/SubmitErrorMessageProvider-vTrI7thu.js';

const Form = ({
  id,
  label,
  onSubmit,
  onValidate,
  defaultValues,
  children
}) => {
  const contextRef = useRef({
    fieldErrors: {}
  });
  // https://react-hook-form.com/api/useform
  const methods = useForm({
    mode: 'onChange',
    context: contextRef.current,
    resolver: async (values, context, options) => {
      var _context$fieldErrors, _options$fields;
      const {
        values: validatedValues,
        errors: validatedErrors
      } = await onValidate(values);
      const fieldErrors = (_context$fieldErrors = context === null || context === void 0 ? void 0 : context.fieldErrors) !== null && _context$fieldErrors !== void 0 ? _context$fieldErrors : {};
      Object.entries((_options$fields = options.fields) !== null && _options$fields !== void 0 ? _options$fields : {}).forEach(([fieldName, {
        validate
      }]) => {
        if (validate) {
          delete fieldErrors[fieldName];
          Object.entries(validate !== null && validate !== void 0 ? validate : {}).forEach(([, validator]) => {
            const message = validator(validatedValues[fieldName]);
            if (typeof message === 'string') {
              fieldErrors[fieldName] = {
                message
              };
            }
          });
        }
      });
      return {
        values: validatedValues,
        errors: {
          ...fieldErrors,
          ...validatedErrors
        }
      };
    },
    defaultValues
  });
  const uid = useUID(id);
  const [submitErrorMessage, setSubmitErrorMessage] = React__default.useState();
  const handleSubmit = useCallback(async submitEvent => {
    const onValid = async (data, event) => {
      setSubmitErrorMessage(undefined);
      const result = await onSubmit(data, event);
      if (result !== null && result !== void 0 && result.error) {
        throw new Error(result.error);
      }
    };
    const onInvalid = errors => {
      const hasErrors = Object.keys(errors).length > 0;
      if (hasErrors) {
        var _Object$entries$;
        const errorMessage = (_Object$entries$ = Object.entries(errors)[0]) === null || _Object$entries$ === void 0 || (_Object$entries$ = _Object$entries$[1]) === null || _Object$entries$ === void 0 ? void 0 : _Object$entries$.message;
        if (typeof errorMessage === 'string') {
          setSubmitErrorMessage(errorMessage);
        }
      }
    };
    try {
      await methods.handleSubmit(onValid, onInvalid)(submitEvent);
    } catch (error) {
      if (error instanceof Error) {
        setSubmitErrorMessage(error.message);
      }
    }
  }, [methods, onSubmit]);
  const formProps = useMemo(() => ({
    label,
    handleSubmit
  }), [label, handleSubmit]);
  return /*#__PURE__*/React__default.createElement(UIDPrefix, {
    value: uid
  }, /*#__PURE__*/React__default.createElement(FormIdProvider, {
    value: uid
  }, /*#__PURE__*/React__default.createElement(SubmitErrorMessageProvider, {
    value: submitErrorMessage
  }, /*#__PURE__*/React__default.createElement(FormProvider, methods, /*#__PURE__*/React__default.createElement(FormElementContext.Provider, {
    value: formProps
  }, children)))));
};

export { Form as F };
//# sourceMappingURL=Form-BQnr15NK.js.map
